import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { WorkOrder } from '../work-order'
import { BehaviorSubject } from 'rxjs'
import { MatIcon } from '@angular/material/icon'
import { AsyncPipe } from '@angular/common'

export enum WorkOrderIndicatorType {
  Info,
  Warning,
  Error,
}

export class WorkOrderIndicator {
  constructor(
    public type: WorkOrderIndicatorType,
    public icon: string
  ) {}
}

@Component({
  selector: 'app-work-order-hints',
  templateUrl: './work-order-hints.component.html',
  styleUrls: ['./work-order-hints.component.scss'],
  imports: [MatIcon, AsyncPipe],
})
export class WorkOrderHintsComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public workOrder$ = new BehaviorSubject<WorkOrder>(null)
  public indicators$ = new BehaviorSubject<WorkOrderIndicator[]>([])

  public IndicatorType = WorkOrderIndicatorType

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set workOrder(workOrder: WorkOrder) {
    this.workOrder$.next(workOrder)
    this.indicators$.next(this.determineIndicators(workOrder))
  }

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public getColor(type: WorkOrderIndicatorType): string {
    switch (type) {
      case WorkOrderIndicatorType.Info:
        return 'primary'
      case WorkOrderIndicatorType.Warning:
        return 'warn'
      case WorkOrderIndicatorType.Error:
        return 'warn'
    }
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private determineIndicators(workOrder: WorkOrder): WorkOrderIndicator[] {
    const indicators = []

    if (workOrder) {
      if (!workOrder.dispatch?.deliveryId) {
        indicators.push(new WorkOrderIndicator(WorkOrderIndicatorType.Warning, 'local_shipping'))
      }
    }

    return indicators
  }
}
